export default [
  {
    title: 'Create Your Narrative',
    subtitle: 'Click “Create” to begin. This is where your story starts—designed to help your business stand out and make an impact.',
    image:  require('@/assets/images/tutorial-1.png'),
    buttons: {
      skip: 'Skip',
      next: 'Next'
    }
  },
  {
    title: 'Guided Questions',
    subtitle: 'You’ll be guided with simple, thoughtful questions. These help shape the foundation of your strategy and bring out the true essence of your business.',
    image:  require('@/assets/images/tutorial-2.png'),
    buttons: {
      skip: 'Skip',
      next: 'Next'
    }
  },
  {
    title: 'Dynamic Intelligence',
    subtitle: 'Our unique Dynamic Intelligence works with your inputs to build a narrative that’s clear, relevant, and powerful—crafted for the right audience.',
    image:  require('@/assets/images/tutorial-3.png'),
    buttons: {
      skip: 'Skip',
      next: 'Next'
    }
  },
  {
    title: 'Vision Statement',
    subtitle: 'Share your bold vision. If you’re unsure, don’t worry—we’ll help transform your strategy and context into a strong statement that reflects your purpose.',
    image:  require('@/assets/images/tutorial-4.png'),
    buttons: {
      skip: 'Skip',
      next: 'Next'
    }
  },
  {
    title: 'Compare Versions',
    subtitle: 'You’ll get two narrative versions in different voices. Choose the one that fits you best—your selection becomes the “Source Code” for all future content generation. The other will be saved for reference.',
    image:  require('@/assets/images/tutorial-5.png'),
    buttons: {
      skip: 'Skip',
      next: 'Next'
    }
  },
  {
    title: 'Your Narrative, Ready to Use',
    subtitle: 'The finalized narrative anchors all communications, ensuring coherence and consistency across campaigns.',
    image:  require('@/assets/images/tutorial-6.png'),
    buttons: {
      skip: 'Skip',
      next: 'Next'
    }
  },
  {
    title: 'Unlock More Possibilities',
    subtitle: 'From your narrative, you can generate much more: key messages, articles, social media posts, and even campaign assets—all aligned with your story.',
    image:  require('@/assets/images/tutorial-7.png'),
    buttons: {
      skip: null,
      next: 'Get Started'
    }
  }
]
